import React from 'react';
import PropTypes from 'prop-types';
import FacilitatorAssessmentSessionsNew from './FacilitatorAssessmentSessionsNew';

const FacilitatorAssessmentSessionsEdit = (props) => {
  const { assessmentSession, ...restProps } = props;

  return (
    <FacilitatorAssessmentSessionsNew
      {...restProps} // Pass through existingProjects, csrfToken, errors, backUrl, currentUser, etc.
      assessmentSession={assessmentSession} // This contains all fields, including timer settings
      formAction={`/facilitator/assessment_sessions/${assessmentSession.id}`}
      formMethod="patch"
      submitLabel="Update Session"
    />
  );
};

FacilitatorAssessmentSessionsEdit.propTypes = {
  assessmentSession: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string,
    projectId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    assessmentType: PropTypes.string,
    expiresAt: PropTypes.string, // Or Date, depending on how it comes from Rails props
    active: PropTypes.bool,
    timerEnabled: PropTypes.bool,
    timerDurationSeconds: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    timerDefaultAction: PropTypes.string,
    // Ensure all fields expected by FacilitatorAssessmentSessionsNew are listed or covered by shape
    newProjectName: PropTypes.string // if FacilitatorAssessmentSessionsNew might use it from assessmentSession prop
  }).isRequired,
  existingProjects: PropTypes.array,
  csrfToken: PropTypes.string.isRequired,
  errors: PropTypes.array,
  backUrl: PropTypes.string.isRequired,
  currentUser: PropTypes.object // Assuming FacilitatorAssessmentSessionsNew might expect this from props
};

export default FacilitatorAssessmentSessionsEdit; 